module.exports = __webpack_public_path__ + "img/ring_y_e_null_null@2x.d0032cad.png";